export default __webpack_public_path__ + "static/media/games-banners.46a4bc60.webp";